import type { TFunction } from 'i18next';
import { isThousandOperand } from '@unified-checkout/design-system';

export const getLocalizedCurrency = (t: TFunction, currency: string) => {
  return t(`innerLayout.currencies.${currency}`).includes('innerLayout') ?
    currency
    :
    t(`innerLayout.currencies.${currency}`);
};

export const convertAmountToCents = (amount: number, currency: string, round?: boolean) => {
  const multipliedAmount = isThousandOperand(currency) ?
    (amount * 1000)
    :
    (amount * 100);

  const correctFloatAmount = parseFloat(multipliedAmount.toFixed(12));

  return round ? Math.round(correctFloatAmount) : correctFloatAmount;
};

export const convertCentsToMajorUnit = (amount: number, currency: string, round?: boolean) => {
  const multipliedAmount = isThousandOperand(currency) ?
    (amount / 1000)
    :
    (amount / 100);

  return round ? Math.round(multipliedAmount) : multipliedAmount;
};

export const convertAmountToFixedDigits = (amount: number, currency: string) => {
  return isThousandOperand(currency) ?
    amount.toFixed(3)
    :
    amount.toFixed(2);
}